import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type BenefitTemplateFilledProps = BusinessIconImageProps & {
  secondaryColor?: string;
};

const BenefitTemplateFilled = ({ size = 24, width, height, alt = '', color = 'currentColor', strokeWidth, style, ...props }: BenefitTemplateFilledProps) =>
  h(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      viewBox: '0 0 24 24',
      fill: color,
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      color,
      "stroke-width": strokeWidth,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(0.5 0.2125) scale(0.71875)',
        },
        [
          h(
            'path',
            {
              d: 'M28.8 2H3.2C1.44 2 0 3.44 0 5.2V27.6C0 29.36 1.44 30.8 3.2 30.8H28.8C30.56 30.8 32 29.36 32 27.6V5.2C32 3.44 30.56 2 28.8 2ZM11.2 24.4H6.4C5.52 24.4 4.8 23.68 4.8 22.8C4.8 21.92 5.52 21.2 6.4 21.2H11.2C12.08 21.2 12.8 21.92 12.8 22.8C12.8 23.68 12.08 24.4 11.2 24.4ZM11.2 18H6.4C5.52 18 4.8 17.28 4.8 16.4C4.8 15.52 5.52 14.8 6.4 14.8H11.2C12.08 14.8 12.8 15.52 12.8 16.4C12.8 17.28 12.08 18 11.2 18ZM11.2 11.6H6.4C5.52 11.6 4.8 10.88 4.8 10C4.8 9.12 5.52 8.4 6.4 8.4H11.2C12.08 8.4 12.8 9.12 12.8 10C12.8 10.88 12.08 11.6 11.2 11.6ZM26.72 14.992L21.648 20.064C21.024 20.688 20 20.688 19.376 20.064L17.12 17.792C16.496 17.168 16.496 16.16 17.12 15.536C17.744 14.912 18.752 14.912 19.376 15.536L20.512 16.672L24.464 12.72C25.088 12.096 26.096 12.096 26.72 12.72L26.736 12.736C27.344 13.36 27.344 14.384 26.72 14.992Z',
            },
          ),
        ],
      ),
    ],
  );

export default BenefitTemplateFilled;
